import { ICategory } from "../../interfaces/ICategory";

export const categoryData: ICategory[] = [
    {
        name: 'Meble modułowe',
        hasArrow: false,
        triggers: ['moduł', 'modul']
    },
    {
        name: 'Narożniki',
        hasArrow: true,
        triggers: ['narożnik', 'naroznik'],
        subcategories: [
            { name: 'Narożniki modułowe', triggers: ['narożnik moduł', 'naroznik modul'] },
            { name: 'Narożniki z funkcją relaks', triggers: ['narożnik relaks', 'naroznik relaks', 'relax naroż'] }
        ]
    },
    {
        name: 'Kanapy',
        hasArrow: false,
        triggers: ['kanapa', 'kanapy']
    },
    {
        name: 'Fotele',
        hasArrow: true,
        triggers: ['fotel', 'fotele'],
        subcategories: [
            { name: 'Fotele z funkcją relaks', triggers: ['fotel relaks', 'fotel relax'] }
        ]
    },
    {
        name: 'Fotele obrotowe',
        hasArrow: false,
        triggers: ['fotel obrot', 'krzesło obrotowe']
    },
    {
        name: 'Biurka',
        hasArrow: true,
        triggers: ['biurko', 'biurka'],
        subcategories: [
            { name: 'Biurka proste', triggers: ['biurko proste'] },
            { name: 'Biurka narożne', triggers: ['biurko naroż', 'biurko naroz'] },
            { name: 'Biurka gabinetowe', triggers: ['biurko gabinet', 'gabinetowe biurko'] },
            { name: 'Biurka dziecięce', triggers: ['biurko dziec'] },
            { name: 'Biurka gamingowe', triggers: ['biurko gaming', 'gaming desk'] },
        ]
    },
    {
        name: 'Szafy',
        hasArrow: true,
        triggers: ['szafa', 'szafy'],
        subcategories: [
            { name: 'Szafy otwierane', triggers: ['szafa otwier'] },
            { name: 'Szafy przseuwne', triggers: ['szafa przesu', 'szafa przesuw'] },
        ]
    },
    {
        name: 'Sofy',
        hasArrow: false,
        triggers: ['sofa', 'sofy']
    },
    {
        name: 'Pufy',
        hasArrow: false,
        triggers: ['pufa', 'puf', 'pufy']
    },
    {
        name: 'Stoły',
        hasArrow: true,
        triggers: ['stół', 'stoły'],
        subcategories: [
            { name: 'Stoły rozkładane', triggers: ['stół rozkład', 'stol rozklad'] },
            { name: 'Stoły nierozkładane', triggers: ['stół nieroz', 'stol nieroz'] },
            { name: 'Stoły okrągłe', triggers: ['stół okrąg', 'stol okrag'] },
            { name: 'Stoły fornirowane', triggers: ['stół fornir', 'stol fornir'] },
            { name: 'Stoły lite drewno', triggers: ['stół lite drewno', 'stol lite drewno'] },
            { name: 'Stoły płyta MDF', triggers: ['stół mdf', 'stol mdf'] },
        ]
    },
    {
        name: 'Krzesła',
        hasArrow: true,
        triggers: ['krzesło', 'krzesla', 'krzesła'],
        subcategories: [
            { name: 'Krzesła tepicerowane', triggers: ['krzesło tapic', 'krzesla tapic'] },
            { name: 'Krzesła siedzisko twarde', triggers: ['krzesło twarde', 'krzesla twarde'] },
            { name: 'Krzesła kuchenne', triggers: ['krzesło kuchenne', 'krzesla kuchenne'] },
            { name: 'Hokery', triggers: ['hoker', 'hokery', 'barowe'] },
        ]
    },
    {
        name: 'Ławy/Stoliki',
        hasArrow: true,
        triggers: ['ław', 'law', 'stolik', 'stoliki'],
        subcategories: [
            { name: 'Stoliki drewniane', triggers: ['stolik drewn', 'ław drew'] },
            { name: 'Stoliki szklane', triggers: ['stolik szkł', 'stolik szkl'] },
            { name: 'Ławostoły', triggers: ['ławostół', 'lawostol'] },
        ]
    },
    {
        name: 'Łóżka',
        hasArrow: true,
        triggers: ['łóżko', 'lozko', 'łóżka', 'lozka'],
        subcategories: [
            { name: 'Łóżka kontynentalne', triggers: ['łóżko kontyn', 'lozko kontyn'] },
            { name: 'Łóżka tapicerowane', triggers: ['łóżko tapic', 'lozko tapic'] },
            { name: 'Łóżka drewniane', triggers: ['łóżko drew', 'lozko drew'] },
            { name: 'Łóżka dziecięce', triggers: ['łóżko dziec', 'lozko dziec'] },
        ]
    },
    {
        name: 'Tapczany',
        hasArrow: false,
        triggers: ['tapczan', 'wersalka']
    },
    {
        name: 'Materace',
        hasArrow: true,
        triggers: ['materac', 'materace'],
        subcategories: [
            { name: 'Materace medyczne', triggers: ['materac medycz'] },
            { name: 'Materace sprężynowe', triggers: ['materac spręż', 'materac sprez'] },
            { name: 'Materace piankowe', triggers: ['materac piank'] },
            { name: 'Materace hotelowe', triggers: ['materac hotel'] },
            { name: 'Materace dziecięce', triggers: ['materac dziec'] },
            { name: 'Materace niemowlęce', triggers: ['materac niemowl'] },
        ]
    },
    {
        name: 'Toppery',
        hasArrow: false,
        triggers: ['topper', 'nakładka', 'nakladka']
    },
    {
        name: 'Komody',
        hasArrow: false,
        triggers: ['komoda', 'komody']
    },
    {
        name: 'Witryny',
        hasArrow: false,
        triggers: ['witryna', 'witryny', 'kredens', 'przeszkl']
    },
    {
        name: 'Szafki RTV',
        hasArrow: false,
        triggers: ['rtv', 'szafka tv', 'tv szafka']
    },
    {
        name: 'Regały',
        hasArrow: false,
        triggers: ['regał', 'regal', 'regały', 'regaly']
    },
    {
        name: 'Półki',
        hasArrow: false,
        triggers: ['półka', 'polka', 'półki', 'polki']
    },
    {
        name: 'Szafki kuchenne',
        hasArrow: false,
        triggers: ['kuchenn', 'kuchnia szaf', 'szafka kuch']
    },
    {
        name: 'Szafki łazienkowe',
        hasArrow: false,
        triggers: ['łazienk', 'lazienk', 'szafka łaz', 'szafka laz']
    },
    {
        name: 'Szafki na buty',
        hasArrow: false,
        triggers: ['buty', 'obuwn', 'na buty']
    },
    {
        name: 'Szafki nocne',
        hasArrow: false,
        triggers: ['nocna', 'szafka noc']
    },
    {
        name: 'Wieszaki',
        hasArrow: false,
        triggers: ['wieszak', 'wieszaki']
    },
    {
        name: 'Lustra',
        hasArrow: true,
        triggers: ['lustro', 'lustra'],
        subcategories: [
            { name: 'Lustra do przedpokoju', triggers: ['lustro przedpok', 'lustro hol'] },
            { name: 'Lustra do salonu', triggers: ['lustro salon'] },
        ]
    },
];